/* global SWDLocalise */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import singleIndex from 'instantsearch.js/es/lib/stateMappings/singleIndex';
import history from 'instantsearch.js/es/lib/routers/history';
import { connectMenu } from 'instantsearch.js/es/connectors';
import { searchBox, stats, pagination } from 'instantsearch.js/es/widgets';
import customHits from './widgets/hits-all';
import googleAnalyticsMiddleware from './google-analytics-middleware';

const searchForm = document.querySelector('.js-search-form');
const searchResults = document.querySelector('.js-search-results');

let firstLoad = true;

const setup = () => {
    const algoliaClient = algoliasearch(
        SWDLocalise.algoliaAppID,
        SWDLocalise.algoliaAPIKey,
    );

    const searchClient = {
        ...algoliaClient,
        search(requests) {
            if (requests.every(({ params }) => !params.query)
                && firstLoad === true) {
                firstLoad = false;
                return Promise.resolve({
                    results: requests.map(() => ({
                        hits: [],
                        nbHits: 0,
                        nbPages: 0,
                        page: 0,
                        processingTimeMS: 0,
                    })),
                });
            }

            return algoliaClient.search(requests);
        },
    };

    const indexName = `${SWDLocalise.algoliaIndex}all`;

    const search = instantsearch({
        searchClient,
        indexName,
        routing: {
            router: history(),
            stateMapping: singleIndex(indexName),
        },
        searchFunction(helper) {
            if (helper.state.query) {
                const page = helper.getPage() || 0;

                helper
                    .toggleFacetRefinement('visibility', 'visible')
                    .setPage(page);
            }

            if (helper.state.page > 0) searchResults.scrollTop = 0;

            helper.search();
        },
    });

    search.use(googleAnalyticsMiddleware);

    const virtualMenu = connectMenu(() => null);

    search.addWidgets([
        virtualMenu({
            attribute: 'visibility',
        }),

        searchBox({
            container: searchForm,
            placeholder: 'Search St Pierre Bakery',
        }),

        stats({
            container: document.querySelector('.js-search-stats'),
        }),

        customHits({
            container: searchResults,
        }),

        pagination({
            container: document.querySelector('.js-search-pagination'),
            scrollTo: true,
        }),
    ]);

    search.start();
};

const init = () => {
    if (!searchForm) return;
    setup();
};

export default init;
